(function () {
  document.querySelectorAll("[data-accordion]").forEach((accordion) => {
    const items = accordion.querySelectorAll(".accordion__item");

    items.forEach((item) => {
      const trigger = item.querySelector(".accordion__trigger");
      const content = item.querySelector(".accordion__content");

      // set initial height if open
      if (item.dataset.state === "open") {
        content.style.height = content.scrollHeight + "px";
      } else {
        content.style.height = "0px";
      }

      trigger.addEventListener("click", () => {
        const isOpen = item.dataset.state === "open";

        items.forEach((i) => {
          const c = i.querySelector(".accordion__content");
          const t = i.querySelector(".accordion__trigger");

          if (i.dataset.state === "open") {
            i.dataset.state = "closed";
            t.setAttribute("aria-expanded", "false");

            c.style.height = c.scrollHeight + "px";

            requestAnimationFrame(() => {
              c.style.height = "0px";
            });
          }
        });

        if (!isOpen) {
          item.dataset.state = "open";
          trigger.setAttribute("aria-expanded", "true");

          const height = content.scrollHeight;

          content.style.height = height + "px";

          content.addEventListener(
            "transitionend",
            () => {
              if (item.dataset.state === "open") {
                content.style.height = "auto";
              }
            },
            { once: true },
          );
        }
      });
    });
  });
})();
